<template>
  <div class="module-resource">
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--      <el-breadcrumb-item>系统管理</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item to="/t/sys/module">模块管理</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>权限管理</el-breadcrumb-item>-->
<!--    </el-breadcrumb>-->
    <el-main class="pageMain">
        <div class="fixedHeader">
            <el-button @click="addResource(0)" type="primary" size="mini" class="btnStyle">单个添加</el-button>
            <el-button type="info" size="mini" class="btnStyle" disabled title="暂无功能">批量导入</el-button>
            <el-button type="info" size="mini" class="btnStyle" disabled title="暂无功能">列表导出</el-button>
            <div class="rightBox">
                <el-button @click="toDetail(1)" type="primary" size="mini" class="btnStyle">编辑</el-button>
                <el-button @click="toDetail(4)" type="primary" size="mini" class="btnStyle">添加下级权限</el-button>
                <el-button @click="toDetail(3)" type="danger" size="mini" class="btnStyle">删除</el-button>
            </div>
        </div>
      <div>

        <el-table
                :data="resources"
                style="width: 100%;margin-bottom: 20px;"
                border
                stripe
                row-key="id"
                default-expand-all
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                @select-all="memberSelect"
                @select="memberSelect"
                ref="table"

        >
            <el-table-column type="selection" :reserve-selection="true" width="55" align="center"></el-table-column>
            <el-table-column prop="displayName" label="权限名称"></el-table-column>
          <el-table-column prop="name" label="权限标识"></el-table-column>
          <el-table-column prop="createTime" label="添加时间"></el-table-column>
          <el-table-column prop="updateTime" label="修改时间"></el-table-column>
<!--          <el-table-column label="操作">-->
<!--            <template slot-scope="scope">-->
<!--              <el-tooltip content="添加下级权限" placement="top">-->
<!--                <el-button-->
<!--                        style="margin-left:10px;"-->
<!--                        @click="addResource(scope.row.id)"-->
<!--                        size="mini"-->
<!--                        icon="el-icon-plus"-->
<!--                        circle-->
<!--                ></el-button>-->
<!--              </el-tooltip>-->
<!--              <el-tooltip content="修改" placement="top">-->
<!--                <el-button-->
<!--                        style="margin-left:10px;"-->
<!--                        @click="updateResource(scope.row)"-->
<!--                        size="mini"-->
<!--                        icon="el-icon-edit"-->
<!--                        circle-->
<!--                ></el-button>-->
<!--              </el-tooltip>-->
<!--              <el-tooltip content="删除" placement="top">-->
<!--                <el-button-->
<!--                        style="margin-left:10px;"-->
<!--                        @click="deleteResource(scope.row)"-->
<!--                        type="danger"-->
<!--                        size="mini"-->
<!--                        icon="el-icon-delete"-->
<!--                        circle-->
<!--                ></el-button>-->
<!--              </el-tooltip>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </div>
    </el-main>

    <!--新加-->
     <el-dialog v-dialogDrag :title="form.id > 0 ? '编辑权限' : '添加权限'" :visible.sync="editDialogVisible" width="700px">
      <el-form :model="form" :rules="rules" ref="form_data" label-width="100px">
        <el-form-item prop="displayName" label="权限名称">
          <el-input v-model.trim="form.displayName" autocomplete="off" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item prop="name" label="权限标识">
          <el-input v-model.trim="form.name" autocomplete="off" maxlength="50" show-word-limit></el-input>
        </el-form-item>
         <!-- <el-form-item>
              <el-checkbox v-model="form.type">超级管理员</el-checkbox>
          </el-form-item>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialogVisible = false" :disabled="loading">取 消</el-button>
        <el-button type="primary" size="medium" @click="save()" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { moduleResourceApi } from "@/api/organization";
import {moduleApi} from "../../api/organization";

export default {
  name: 'Sys_Resource',
  data() {
    return {
      resources: [],
      editDialogVisible: false,
      loading:false,
      moduleId:0,
      selectModule: {},
      rules: {
        name: [
          { required: true, message: "请输入权限标识", trigger: "blur" }
        ],
        displayName: [
          { required: true, message: "请输入权限名称", trigger: "blur" }
        ]
      },
      defaultProps: {
        children: "children",
        label: "displayName"
      },
      form: {},
      allSelected: [],
    };
  },
  created() {
    this.moduleId = this.$route.params.id;
    this.listResources();
  },
  methods: {
      //0新增  1编辑 2查看  3删除  4添加下级权限
      toDetail(type){
          const dataArr = this.allSelected;
          if(type !== 0){
              if(dataArr.length == 0){
                  this.$message.error("请先勾选");
                  return;
              }
              if(type == 3){
                  this.del(dataArr);
                  return;
              }
              if(dataArr.length > 1 && (type == 1 || type == 2 || type == 4)){
                  this.$message.error("只能勾选一条");
                  return;
              }
          }
          if(type == 1){
              this.updateResource(dataArr[0]);
          }else if(type == 4){
              this.addResource(dataArr[0].id);
          }
      },
      memberSelect(selection, row) {
          this.allSelected = selection;
      },
      handleClick(){
          this.allSelected = [];
          let $table = this.$refs.table;
          if($table){
              $table.clearSelection();
          }
          this.listResources();
      },
    goBack(){
      this.$router.go(-1);
    },
    listResources() {
      moduleResourceApi.treeByModule(this.moduleId).then(response => {
        const { data } = response;
        this.resources = data.data;
          this.$nextTick(()=>{
              let $table = this.$refs.table;
              if($table){
                  $table.doLayout();
              }
          })
      });
    },
    addResource(parentId){
      this.editDialogVisible = true;
      this.$nextTick(()=>{
        this.$refs['form_data'].resetFields();
        this.form = {parentId:parentId,moduleId:this.moduleId, type: false};
          this.handleClick();
      });
    },
    updateResource(resource){
      this.editDialogVisible = true;
      this.$nextTick(()=>{
        this.$refs['form_data'].resetFields();
        resource.type = resource.type?true:false;
        this.form = Object.assign({}, resource, {children:[]});
      });
    },
      del(dataArr){
          this.$confirm('确定要删除'+dataArr.flatMap((e)=>e.displayName).join(",")+'？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              moduleResourceApi.delete({ids: dataArr.flatMap((e)=>e.id).join(",")}).then(r => {
                  if (r.data.result === 0) {
                      this.$message.success("删除成功");
                      this.handleClick();
                  }
              })
          }).catch(() => {
              console.log("取消")
          });
      },
    save() {
      this.$refs["form_data"].validate(valid => {
        if (valid) {
          this.loading = true;
          let request;
          let form = JSON.parse(JSON.stringify(this.form));
          form.type = form.type?1:0;
          if(form.id){
            request = moduleResourceApi.update(form)
          } else {
            request = moduleResourceApi.add(form)
          }

          request.then(r => {
            this.loading = false;
            if(r.data.result === 0){
              this.editDialogVisible = false;
                this.handleClick();
            } else {
              this.$alert(r.data.message, "提示", {type:"error"});
            }
          }).catch(()=>{
            this.loading = false;
          })
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.module-resource {
  .el-main {
    .submitBox {
      margin-bottom: 10px;
      .el-page-header__left{
        color: #c0c4cc;
        .el-icon-back{font-size: 22px;}
        .el-page-header__title{font-size: 16px;}
        &:hover{
          color: #67c23a;
        }
      }
    }
    .tree {
      width: 500px;
    }
  }
}
</style>
